<template>
  <div v-if="documentoProps != null">
    <div class="content">

      <div>
        <p class="titulo">{{documentoProps.Titulo}}</p>
      </div>

      <pre v-html="documentoProps.Conteudo" class="conteudo_ok">{{ documentoProps.Conteudo }}</pre>

      <div v-if="documentoProps.UrlImagens.length" id="slider">
        <carousel-3d :autoplay="true"  :autoplay-timeout="5000" :perspective="50" :space="200" :display="3" :width="$vssWidth > 760 ? $vssWidth > 1000 ? 600 : 450 : 300" :height="$vssWidth > 760 ? $vssWidth > 1000 ? 430 : 400 : 390" :border="0" :controlsVisible="true">
          <slide v-for="(imagem, i) in documentoProps.UrlImagens" :index="i" :key="i">
              <div class="slider-div">
                <div class="outer-div">
                  <div :style="{'background': 'url(' + imagem + ')', 'background-size': 'cover', 'background-repeat': 'no-repeat'}" class="inner-div"></div>
                </div>
                <p class="legenda">{{ documentoProps.LegendasImagens[i] }}</p>
            </div>
          </slide>
        </carousel-3d>
      </div>

      <div v-if="documentoProps.MapaGoogle != null">
        <pre v-html="documentoProps.MapaGoogle">{{ documentoProps.MapaGoogle }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from '@/firebase.js'
import { Carousel3d, Slide } from 'vue-carousel-3d'
import VueScreenSize from 'vue-screen-size'

export default {
  name: 'Paginas',
  mixins: [VueScreenSize.VueScreenSizeMixin],
  props: ['id'],
  components: {
    Carousel3d,
    Slide,
    db
  },
  data () {
    return {
      slides: 3,
      documentoProps: null,
      videoEmbed: null,
      tiposPagina: []
    }
  },
  created () {
    this.getDocumentoProps()
    document.title = 'Promoções - Ilha do Caranguejo'
  },
  methods: {
    async getDocumentoProps () {
      let loader = this.$loading.show({
        container: null,
        fullPage: true,
        color: '#F85E28',
        loader: 'spinner',
        width: 100,
        height: 100,
        backgroundColor: '#ffffff',
        opacity: 0.5,
        zIndex: 999
      })
      var docRef = db.collection('Paginas').doc(this.id)
      docRef
        .get()
        .then(doc => {
          if (doc.exists) {
            this.documentoProps = doc.data()
            document.title = doc.data().Titulo + ' - Ilha do Caranguejo'
            loader.hide()
          } else {
            loader.hide()
          }
        })
        .catch(erro => {
          loader.hide()
        })
    }
  }
}
</script>

<style scoped>

.content {
  width: 90%;
  max-width: 960px;
  margin: 40px auto 0 auto;
  padding: 20px;
  display: grid;
  grid-template-columns: 1fr;
  background: #fff;
}

.content img {
  margin: 0 auto;
}

.titulo {
  font-size: 1.4rem;
  color: #2E9189;
  font-weight: 600;
  border-bottom: 1px solid #2E9189;
  padding: 5px 0;
  margin: 0 0 15px 0;
}

.conteudo_ok {
  font-size: 1em;
  line-height: 1.6;
  text-align: center;
  font-family: "Montserrat", Open Sans, Helvetica, Arial, sans-serif;
  word-wrap: break-word;
  white-space: pre-wrap;       /* Since CSS 2.1 */
  white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
  white-space: -pre-wrap;      /* Opera 4-6 */
  white-space: -o-pre-wrap;    /* Opera 7 */
  word-wrap: break-word;
}

#slider {
  margin-top: 10px;
}

.carousel-3d-container figure {
  margin:0;
}

.carousel-3d-container figcaption {
  position: absolute;
  color: #fff;
  bottom: 0;
  position: absolute;
  bottom: 0;
  padding: 15px;
  font-size: 12px;
  min-width: 100%;
  box-sizing: border-box;
}

.outer-div {
  width: 600px;
  height: 400px;
  overflow: hidden;
  margin: 0 0 12px 0;
}

.inner-div {
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: center;
}

.legenda {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Paginas.vue